"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ViewButtons = ({
  className,
  children
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, children);

var _default = (0, _styledComponents.default)(ViewButtons).withConfig({
  displayName: "ViewButtons",
  componentId: "sc-1lrvwwu-0"
})(["box-sizing:content-box;align-items:center;border-top:1px solid #dfdfdf;display:flex;justify-content:flex-end;flex-shrink:0;padding:0 16px;height:80px;& > button{margin:0;&:not(:last-child){margin-right:16px;}}"]);

exports.default = _default;